import { __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { Button } from 'antd';
import { useContextSelector } from 'use-context-selector';
import styled from '../../../../styled';
import LayoutContext from '../../../context';
const UserMenuItem = React.forwardRef((_a, ref) => {
    var { id, className, icon, disabled, onClick, children, preventClose, as: Tag } = _a, rest = __rest(_a, ["id", "className", "icon", "disabled", "onClick", "children", "preventClose", "as"]);
    const close = useContextSelector(LayoutContext, context => context.userMenu.falseOpened);
    const handleClick = React.useCallback((e) => {
        onClick && onClick(e);
        !preventClose && close();
    }, [close, onClick, preventClose]);
    let content = (_jsx(Button, Object.assign({ id: id, icon: icon, ref: ref, block: true, type: 'text', onClick: handleClick, className: className, disabled: disabled }, { children: children })));
    if (Tag) {
        content = (_jsx(Tag, Object.assign({ id: id }, rest, { children: content })));
    }
    return _jsx(_Fragment, { children: content });
});
export default styled(UserMenuItem, { label: 'hst-user-menu-item' }) `
  justify-content: start;
  align-items: center;
  text-align: left;
  font-size: 16px;
  padding: 8px 16px;
  display: flex;

  & > span:not(.anticon, .ant-avatar) {
    max-width: 235px;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  & > .anticon {
    font-size: 20px;
  }

  & > svg {
    width: 24px;
    margin-right: 5px;
  }

  &.hst-button-disabled {
    background-color: transparent;
  }
`;
